export default "__VITE_ASSET__CmcXcYlv__"